"use strict";var isObject=require("lodash.isobject");module.exports=function(e){for(var s in e){var o=e[s];if(isObject(o))for(var t in o){var a=o[t];isObject(a)||console.warn("Make sure the value of the element `"+s+"` is an object of css. You passed it `"+o+"`")}else console.warn("Make sure the value of `"+s+"` is an object of html elements. You passed it `"+o+"`")}};


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactcss/lib/check-class-structure.js
 ** module id = 885
 ** module chunks = 0
 **/